export const sections = [
    {
        type: "Saxophones",
        instruments: [
            { name: 'Soprano sax (Bb)', clean: 'soprano_sax_bb', key: 'Bb' },
            { name: 'Alto sax (Eb)', clean: 'alto_sax_eb', key: 'Eb' },
            { name: 'Tenor sax (Bb)', clean: 'tenor_sax_bb', key: 'Bb' },
            { name: 'Baritone sax (Eb)', clean: 'baritone_sax_eb', key: 'Eb' }
        ],
    }, {
        type: "Other woodwinds",
        instruments: [
            { name: 'Clarinet (Bb)', clean: 'clarinet_bb', key: 'Bb' },
            { name: 'Flute', clean: 'flute', key: 'C' }
        ]
    }, {
        type: "Brass instruments",
        instruments: [
            { name: 'Trombone', clean: 'trombone', key: 'C-bass' }, // TODO
            { name: 'Trumpet (Bb)', clean: 'trumpet_bb', key: 'Bb' },
            { name: 'Tuba', clean: 'tuba', key: 'C' }, // TODO
            { name: 'Baritone horn', clean: 'baritone_horn', key: 'Bb' } // TODO
        ]
    }, {
        type: "Rhythm instruments",
        instruments: [
            { name: 'Bass', clean: 'bass', key: 'C-bass' },
            { name: 'Drums', clean: 'drums', key: 'C' }, // TODO
            { name: 'Guitar', clean: 'guitar', key: 'C' }, // TODO
            { name: 'Piano', clean: 'piano', key: 'C' }
        ]
    }, {
        type: "Strings and voice",
        instruments: [
            { name: 'Violin/Viola', clean: 'violin_viola', key: 'C' }, // TODO
            { name: 'Cello', clean: 'cello', key: 'C' }, // TODO
            { name: 'Voice', clean: 'voice', key: 'C' } // TODO
        ]
    }
];

export const instruments = sections.map(group => group.instruments).reduce((p, c) => [...p, ...c]);

export const songs = [
    { name: 'Big Bertha', clean: 'big_bertha' },
    { name: 'Blues By Five', clean: 'blues_by_five' },
    { name: 'Cold Duck Time', clean: 'cold_duck_time' },
    { name: 'Fantasy in D', clean: 'fantasy_in_d' },
    { name: 'Jeannine', clean: 'jeannine' },
    { name: 'Killer Joe', clean: 'killer_joe' },
    { name: 'Little Sunflower', clean: 'little_sunflower' },
    { name: 'Mercy Mercy Mercy', clean: 'mercy_mercy_mercy' },
    { name: 'Mr. PC', clean: 'mr_pc' },
    { name: 'So Danço Samba', clean: 'so_danco_samba' },
    { name: 'Song For My Father', clean: 'song_for_my_father' },
    { name: 'Tenor Madness', clean: 'tenor_madness' },
    { name: 'Whisper Not', clean: 'whisper_not' },
    { name: 'Work Song', clean: 'work_song' },
    { name: 'Yardbird Suite', clean: 'yardbird_suite' }
];

export const parts = [
    { name: 'Drums', clean: 'Drums', scoreAlias: 'Part_1' },
    { name: 'Bass', clean: 'Bass', scoreAlias: 'Part_1' },
    { name: 'Piano/Guitar', clean: 'Piano-Guitar', scoreAlias: 'Part_1' },
    { name: 'Part 1 melody', clean: 'Part_1' },
    { name: 'Part 2 harmony', clean: 'Part_2' },
    { name: 'Part 3 harmony', clean: 'Part_3' }
]